import React from 'react';
import {
  FormPageInputItemTextZipCode,
  FormPageInputItemTextZipCodeWithoutHyphen,
  TextPropertyZipCode,
  TextPropertyZipCodeWithoutHyphen,
  TEXT_PROPERTY_INPUT_TYPE,
} from 'shared';
import { hasErrorMessage } from '../shared';
import { TextZipCode } from './TextZipCode';
import { TextZipCodeWithoutHyphen } from './TextZipCodeWithoutHyphen';
import { FormFieldZipCodeInputProps, TextInputProps } from './shared';

const isError = (
  errorMessages: TextInputProps['errorMessages'],
  displayError = false,
): boolean => !!displayError && hasErrorMessage(errorMessages);

type TextZipCodeInputProps = FormFieldZipCodeInputProps;

export const TextZipCodeInput: React.FC<TextZipCodeInputProps> = (props) => {
  switch (props.property.inputFormat.inputType) {
    case TEXT_PROPERTY_INPUT_TYPE.zipCode: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldZipCodeInputProps<
          TextPropertyZipCode,
          FormPageInputItemTextZipCode
        >;
      const displayError =
        submitted || (touched && touched.first && touched.second);
      return (
        <TextZipCode
          first={value.first}
          second={value.second}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case TEXT_PROPERTY_INPUT_TYPE.zipCodeWithoutHyphen: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldZipCodeInputProps<
          TextPropertyZipCodeWithoutHyphen,
          FormPageInputItemTextZipCodeWithoutHyphen
        >;
      const displayError = submitted || (touched && touched.zipCode);
      return (
        <TextZipCodeWithoutHyphen
          zipCode={value.zipCode}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    default: {
      return null;
    }
  }
};
